export default __webpack_public_path__ + "static/media/archive.1f5de4a7.svg";